package com.essntl.features.itinerary.ui.send_message

import com.essntl.features.itinerary.domain.model.ItineraryServiceModel
import com.essntl.features.itinerary.ui.edit_itinerary.MessageSendType
import com.essntl.features.message.domain.model.MessageModel
import com.essntl.features.service.domain.model.service.ServiceModel

sealed interface SendMessageEvent {
    data class GetItinerary(val itineraryId: String) : SendMessageEvent
    data class GetItineraryServices(
        val itineraryServiceId: String,
        val itineraryServices: List<ItineraryServiceModel>,
    ) : SendMessageEvent

    data class SendMessageList(
        val messageList: List<MessageModel>,
        val type: MessageSendType,
    ) : SendMessageEvent

    data class CheckContact(val contactId: String) : SendMessageEvent

    data class SendToWhatsappGroup(
        val subject: String,
        val phoneNumbers: List<String>,
        val messageList: List<MessageModel>,
        val type: MessageSendType,
    ) : SendMessageEvent

    data class SendContact(val to: String) : SendMessageEvent

    data object GetEmails : SendMessageEvent
}